import { filterApprovedVendors } from '@/constants/suppliers'
import type { Vendor } from '@/services/api/vendors'

/** Contract supplier dropdown — only approved names per KCG ops (7/06). */
export function vendorsForContractPicker(vendors: Vendor[]): Vendor[] {
  return filterApprovedVendors(vendors)
}
